import React, { Component } from "react";
import styled from "styled-components";
import { Container, Row, Col } from "styled-bootstrap-grid";
import Footer from "../../../Shared/Footer";
import { connect } from "react-redux";
import { userDataTech, fetchLocalData } from "../../../../Actions/UserTechData";
import { withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";
import { logoutUser } from "../../../../Actions";
import TimeInput from "../../../Shared/TimeInput";
import {
  stringToHours,
  TimeConverstion,
  checkObjectChangeArray,
} from "../../../../Api/Utils/ReuseableFunctions";
import { saveTechnicianWorkHours } from "../../../../Actions/TechnicianTimesheet";
class CallOut extends Component {
  constructor(props) {
    super(props);
    // let callOut = props.saveData.callOuts
    //   ? props.saveData.callOuts.length > 0
    //   : false;
    let formData = props.saveData.callOuts ? props.saveData.callOuts[0] : null;
    this.state = {
      formData: {
        callOutHours: formData ? formData.callOutHours : 0,
        callOutNr: formData ? formData.callOutNr : 0,
        calloutBusinessToBusiness: formData
          ? formData.calloutBusinessToBusiness
          : 0,
        calloutHomeToBusiness: formData ? formData.calloutHomeToBusiness : 0,
        paymentType: formData ? formData.paymentType : "",
      },
    };
    this.handleFormChange = this.handleFormChange.bind(this);
  }

  handleChange = (event) => {
    let formData = JSON.parse(JSON.stringify(this.state.formData));
    if (event.target.name === "callOutHours") {
      formData[event.target.name] = stringToHours(event.target.value);
    } else {
      formData[event.target.name] = Number(event.target.value);
    }
    this.setState({ formData });
  };

  handleFormChange(val, name) {
    let formData = this.state.formData;
    formData["callOutHours"] = stringToHours(val);
    this.setState({ formData });
  }

  componentDidMount() {
    if (Object.keys(this.props.saveData).length === 0) {
      this.props.dispatch(fetchLocalData());
      // this.props.history.push("hourslogin");
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.saveMessage !== void 0 &&
      this.props.saveMessage.type === "Timesheet Saved Successfully" &&
      this.props.saveMessage.message.errorCd === "SUCCESS"
    ) {
      let payload = {
        technicianId: this.props.ssoId,
        branchId: this.props.branchId,
        clckInOut: "OUT",
        reasonCd: "43",
        signedInBy: null,
        signedOutBy: this.props.ssoId,
        comments: null,
      };
      this.props.dispatch(logoutUser(payload));
    }
    if (prevProps !== this.props) {
      if (this.props.saveData === null) {
        this.props.history.push("hourslogin");
      }
    }
  }

  submitForm = (nextFlag) => {
    var data = this.props.saveData;
    data.isCallOutOrRoadside = "Y";
    data.callOuts = [this.state.formData];
    data.callOuts = data.callOuts.filter(
      (callOut) => callOut.callOutHours !== 0 && callOut.callOutHours !== 0
    );
    this.props.dispatch(userDataTech(data));
    if (
      this.props.security &&
      nextFlag &&
      (this.props.security.timeForTime === "Y" ||
        this.props.security.timeForTime === "B")
    ) {
      this.props.history.push("hoursadjustment&payment");
    } else {
      if (this.props.security.timeForTime === "T") {
        data.paymentType = "T";
        data.callOuts.forEach((items) => (items.paymentType = "T"));
      }
      if (this.props.security.timeForTime === "N") {
        data.paymentType = "P";
        data.callOuts.forEach((items) => (items.paymentType = "P"));
      }

      this.props.dispatch(saveTechnicianWorkHours(data));
    }
  };

  backStep = () => {
    this.props.history.push("hourslogin");
  };

  render() {
    const { formData } = this.state;
    const { security } = this.props;
    var nextFlag = false;
    if (this.props.techData && this.props.techData.isBeforeSubmitted === "N") {
      nextFlag =
        this.props.security &&
        (this.props.security.timeForTime === "Y" ||
          this.props.security.timeForTime === "B");
    } else {
      nextFlag =
        this.props.security &&
        (this.props.security.timeForTime === "Y" ||
          this.props.security.timeForTime === "B") &&
        checkObjectChangeArray([formData], this.props.techData.callOuts);
    }

    return (
      <ParentDiv>
        <TextMessage>
          <Trans>enterDetailsForCallOutRoadsideActivities</Trans>
        </TextMessage>
        <Container>
          <RowContainer>
            <Col col md="6">
              <FieldsDiv>
                <Fields>
                  <Trans>numberOfCallOuts</Trans>
                </Fields>
                <Fields>
                  <Trans>homeToBusinessKms</Trans>
                </Fields>
                <Fields>
                  <Trans>BusinessToBusinessKms</Trans>
                </Fields>
                <Fields>
                  <Trans>hours</Trans>
                </Fields>
              </FieldsDiv>
            </Col>
            <Col col md="6">
              <InputFieldDiv>
                <RowInput>
                  <Input
                    type="number"
                    onChange={this.handleChange}
                    name="callOutNr"
                    value={formData.callOutNr}
                    min={0}
                  />
                </RowInput>
                <RowInput>
                  <Input
                    type="number"
                    onChange={this.handleChange}
                    name="calloutHomeToBusiness"
                    value={formData.calloutHomeToBusiness}
                    min={0}
                  />
                </RowInput>
                <RowInput>
                  <Input
                    type="number"
                    onChange={this.handleChange}
                    name="calloutBusinessToBusiness"
                    value={formData.calloutBusinessToBusiness}
                    min={0}
                  />
                </RowInput>
                <RowInput>
                  <TimeInput
                    breakCal={security.enableBreaksCal === "Y"}
                    target="callOutHours"
                    showMinInt={security.showMintInt === "Y"}
                    time={TimeConverstion(formData.callOutHours)}
                    setTime={this.handleFormChange}
                  />
                </RowInput>
              </InputFieldDiv>
            </Col>
          </RowContainer>
        </Container>
        <Footer>
          {" "}
          <BackButton onClick={this.backStep}>
            <Trans>back</Trans>
          </BackButton>
          <ButtonSubmit
            onClick={() => {
              this.submitForm(nextFlag);
            }}
          >
            {nextFlag ? <Trans>next</Trans> : <Trans>submitAndLogout</Trans>}
          </ButtonSubmit>
        </Footer>
      </ParentDiv>
    );
  }
}

const mapStateToProps = ({
  userMessage,
  userTechData,
  technicianTimesheet,
  saveTechnicianTimesheet,
  fetchTimesheetSecurity,
  auth,
}) => {
  return {
    message: userMessage,
    saveData: userTechData.payload,
    techData: technicianTimesheet.payload,
    saveMessage: saveTechnicianTimesheet,
    security: fetchTimesheetSecurity.securityList,
    ssoId: auth.ssoId,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
  };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(CallOut)));
const ButtonSubmit = styled.button`
  background: ${(props) => (props.Color ? "#e1e5eb" : "#c4151c")};
  border-radius: 30px;
  padding: 0;
  border: ${(props) => (props.Color ? "1px solid #96989a;" : "none")};
  height: 37px;
  width: 145px;
  color: ${(props) => (props.Color ? "#939292;" : "#ffffff")};
  font-weight: 50;
  position: relative;
  left: 40px;
  font-size: 12px;
  &:disabled {
    cursor: not-allowed;
    background: #e1e5eb;
    color: #939292;
    border: 1px solid #96989a;
  }
`;
const BackButton = styled.button`
  border: 2px solid #e0e0e0;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  background: #ffffff;
  color: #434f5b;
  font-size: 12px;
`;
const TextMessage = styled.div`
  position: relative;
  font-weight: 400;
  color: #464040;
  text-align: center;
  border-bottom: 1px solid #e0d5d5;
  width: 70%;
  left: 17%;
  padding-bottom: 12px;
  font-size: 24px;
`;
const ParentDiv = styled.div`
  text-align: center;
  padding-top: 60px;
  font-family: Trebuchet MS;
  color: #434f5b;
`;
const Fields = styled.div`
  background: #f1f4f9;
  width: auto;
  height: auto;
  border-radius: 2px;
  margin-top: 16px;
  position: relative;
  border: 1px solid #babec3;
  text-align: left;
  padding: 2px 8px 0px 8px;
`;
const Input = styled.input`
  border-radius: 3px;
  position: relative;
  background: ${(props) => (props.color === "silver" ? " #ebeef3" : "white")};
  width: 40%;
  border: 1px solid #babec3;
  height: 30px;
  text-align: center;
  padding: 2px 8px 0px 8px;
`;
const RowInput = styled.div`
  position: relative;
  margin: 15px 0;
`;
const InputFieldDiv = styled.div`
  float: left;
`;
const FieldsDiv = styled.div`
  float: right;
`;
const RowContainer = styled(Row)`
  padding-left: 90px;
`;
